import { render, staticRenderFns } from "./ModelingPatternsList.vue?vue&type=template&id=73e85d11&scoped=true&"
import script from "./ModelingPatternsList.vue?vue&type=script&lang=js&"
export * from "./ModelingPatternsList.vue?vue&type=script&lang=js&"
import style0 from "./ModelingPatternsList.vue?vue&type=style&index=0&id=73e85d11&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e85d11",
  null
  
)

export default component.exports